import React from "react"
import img from "../../assets/BenSunflowers.png"
import { Mortarboard } from "react-bootstrap-icons"

export default function BenAbout() {
  const qualifications = [
    "PhD in  in Counselling Psychology (PsychD)",
    "MSc in Health Psychology",
    "BSc in Psychology",
    "Chartered Psychologist (CPsychol)"
  ]

  return (
    <section id="about" className="benAboutSection">
      <div className="profile-container">
        <div className="benAboutIntro">
          <div className="benAboutEyebrowWrap">
            <span className="benAboutEyebrowLine"></span>
            <p className="benAboutEyebrow mb-0">GET TO KNOW ME</p>
            <span className="benAboutEyebrowLine"></span>
          </div>

          <h1 className="benAboutHeading mb-0">About</h1>
        </div>

        <div className="row align-items-start g-4 g-lg-5">
          <div className="col-lg-5">
            <div className="benAboutCard">
              <img
                src={img}
                alt="Outdoors and reflection"
                className="benAboutImage"
              />

              <div className="benAboutCardBody">
                <p className="benAboutName mb-3">Dr Benjamin Piper</p>

                <div className="benAboutQualifications">
                  {qualifications.map((item) => (
                    <div className="benAboutQualificationItem" key={item}>
                      <div className="benAboutQualificationIcon">
                        <Mortarboard size={16} />
                      </div>
                      <span>{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-7">
            <div className="benAboutTextWrap">
              <p className="benAboutLead">
                I am a Chartered Counselling Psychologist based in London and
                the Clinical Lead at iRise Psychology. I am registered with both
                the Health and Care Professions Council and the British
                Psychological Society.
              </p>

              <p className="benAboutText">
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book.
              </p>

              <p className="benAboutText">
                It has survived not only five centuries, but also the leap into
                electronic typesetting, remaining essentially unchanged. It was
                popularised in the 1960s with the release of Letraset sheets
                containing Lorem Ipsum passages.
              </p>

              <p className="benAboutText mb-0">
                More recently with desktop publishing software like Aldus
                PageMaker including versions of Lorem Ipsum. Contrary to popular
                belief, Lorem Ipsum is not simply random text.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}